import { createContext, useContext } from "react";

const defaultSettingsContext = {};

// TODO: SettingsContext should stay private, every component should rely on useSettings
export const SettingsContext = createContext(defaultSettingsContext);

export const useSettings = () => {
    const context = useContext(SettingsContext);

    if (context === defaultSettingsContext) {
        throw new Error("useSettings must be used within a SettingsProvider");
    }

    return context;
};
